import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { USER_ROLES } from '../../utils/constant';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ProductDetails from '../dashboard/product-details';
import CategoryWiseActionItems from '../investorOverview/mutualFund/CategoryWiseActionItems';
import DirectEquity from '../investorOverview/directEquity';
import PMS from '../investorOverview/pms';
import Alternates from '../investorOverview/alternates';
import Bonds from '../investorOverview/bonds';
import { isModuleAllowed } from '../../utils/utilityFunctions';
import ProtectedRoute from '../../routes/ProtectedRoute';
import { CommonLayout } from '../commonComponents';
import Insurance from '../investorOverview/insurance';


function ProductRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);

    return (
        <Switch>
            <ProtectedRoute
                exact
                path={`${path}/mutual-fund`}
                component={ProductDetails}
                customAuthorizationCheck={
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    (
                        isModuleAllowed({ value: 'MFOrders', compareArr: permissions, objKey: "permissonCode" }) ||
                        isModuleAllowed({ value: 'OrderRecommend', compareArr: permissions, objKey: "permissonCode" })
                    )
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/mutual-fund/category-wise-breakup`}
                component={CategoryWiseActionItems}
                customAuthorizationCheck={
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    (
                        isModuleAllowed({ value: 'MFOrders', compareArr: permissions, objKey: "permissonCode" }) ||
                        isModuleAllowed({ value: 'OrderRecommend', compareArr: permissions, objKey: "permissonCode" })
                    )
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/direct-equity`}
                component={DirectEquity}
                customAuthorizationCheck={
                    isModuleAllowed({ value: 'DirectEQDashboard', compareArr: permissions, objKey: "permissonCode" }) &&
                    ![USER_ROLES.INVESTOR].includes(role)
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/pms`}
                component={PMS}
                customAuthorizationCheck={
                    isModuleAllowed({ value: 'PMSDashboard', compareArr: permissions, objKey: "permissonCode" }) &&
                    ![USER_ROLES.INVESTOR].includes(role)
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/debt`}
                component={Bonds}
                customAuthorizationCheck={
                    isModuleAllowed({ value: 'DebtDashboard', compareArr: permissions, objKey: "permissonCode" }) &&
                    ![USER_ROLES.INVESTOR].includes(role)
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/alternates`}
                component={Alternates}
                customAuthorizationCheck={
                    isModuleAllowed({ value: 'AIFDashboard', compareArr: permissions, objKey: "permissonCode" }) &&
                    ![USER_ROLES.INVESTOR].includes(role)
                }
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/insurance`}
                component={Insurance}
                customAuthorizationCheck={
                    isModuleAllowed({ value: 'INSDashboard', compareArr: permissions, objKey: "permissonCode" }) &&
                    ![USER_ROLES.INVESTOR].includes(role)
                }
                layout={CommonLayout}
            />
        </Switch>
    );
}
export default function ProductsRouter(): JSX.Element {
    return (
        // <CommonLayout>
        <ProductRoutes />
        // </CommonLayout>
    )
}